"use client";

import Image from "next/image";

/**
 * Bookmark Icon Component
 *
 * Navigation icon with Default and Active states.
 * Figma: Bookmark Page Icon (Node: 1:2896)
 *
 * Dimensions: 31.5px × 31.5px container
 * Note: bookmark.svg is the correct navbar bookmark icon
 */

type BookmarkIconSize = "default" | "mobile";

interface BookmarkIconProps {
  active?: boolean;
  size?: BookmarkIconSize;
  className?: string;
  onClick?: () => void;
}

const BASE_DIMENSIONS = {
  container: 31.5,
  iconWidth: 11,
  iconHeight: 14,
} as const;

const BOOKMARK_ICON_SIZES: Record<BookmarkIconSize, number> = {
  default: BASE_DIMENSIONS.container,
  mobile: 40,
};

export function BookmarkIcon({
  active = false,
  size = "default",
  className = "",
  onClick,
}: BookmarkIconProps) {
  // Single bookmark.svg for navbar - active state uses filled styling or background
  const iconSrc = "/icons/bookmark.svg";
  const containerSize = BOOKMARK_ICON_SIZES[size];
  const scale = containerSize / BASE_DIMENSIONS.container;
  const iconWidth = BASE_DIMENSIONS.iconWidth * scale;
  const iconHeight = BASE_DIMENSIONS.iconHeight * scale;

  return (
    <button
      onClick={onClick}
      className={`relative flex items-center justify-center overflow-hidden transition-opacity hover:opacity-80 ${className}`}
      data-testid="saved-items-icon"
      aria-label={active ? "Remove bookmark" : "Add bookmark"}
      style={{
        width: `${containerSize}px`,
        height: `${containerSize}px`,
        backgroundColor: active ? "#E9EBEF" : "transparent", // colors.accent.veryLightBlueGray when active
        borderRadius: "50%",
      }}
    >
      <Image src={iconSrc} alt="" width={iconWidth} height={iconHeight} className="relative" />
    </button>
  );
}
